import script from "./ScoreBoard.vue?vue&type=script&setup=true&lang=ts"
export * from "./ScoreBoard.vue?vue&type=script&setup=true&lang=ts"

import "./ScoreBoard.vue?vue&type=style&index=0&id=549f92d4&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-549f92d4"]])

export default __exports__